module.exports = __webpack_public_path__ + "img/machvat_no.df376156.png";